import { Component, Inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { WINDOW } from '@core/injectors';
import { ProductItemDTO } from '@core/models';
import { InfoMessagesService } from '@features/info-messages';

@Component({
  selector: 'app-product-tile-organizations',
  templateUrl: './product-tile-organizations.component.html',
  styleUrl: './product-tile-organizations.component.scss',
  standalone: false,
})
export class ProductTileOrganizationsComponent {
  product = input.required<ProductItemDTO>();

  constructor(
    private readonly router: Router,
    private readonly infoMessagesService: InfoMessagesService,
    @Inject(WINDOW) private readonly win: Window,
  ) {}

  onProductClick(product: ProductItemDTO) {
    if (product.url) {
      let newTab: WindowProxy | null;
      if (product.title === 'Snowflake' && product?.use_sso) {
        const tree = this.router.createUrlTree(['sso/snowflake_sso_login'], {
          queryParams: { link: product.url },
        });
        const url = this.router.serializeUrl(tree);
        const fullUrl = `${this.win.location.origin}${url}`;
        newTab = this.win.open(fullUrl, '_blank');
      } else {
        newTab = this.win.open(product.url, '_blank');
      }
      if (!newTab) {
        this.infoMessagesService.showError(
          "The link couldn't be opened. Please allow popups in your browser and try again.",
        );
      }
    }
  }
}
